import { createFileRoute } from '@tanstack/react-router'

import { PharaohNextScope } from '#/lib/pharaoh-next/pharaoh-next-scope.tsx'
import { ActivityQuestionsPage } from '#/modules/documentation/back-office/activity-questions-page/activity-questions-page.tsx'

export const Route = createFileRoute('/bo/documentation/activity-specific-questions')({
  // This static catalogue has no leaf permission requirement. Keep BackofficePage's reactive
  // access check and in-place login invitation: requirePermissions would introduce a redirect.
  component: () => (
    <PharaohNextScope surface="bo">
      <ActivityQuestionsPage />
    </PharaohNextScope>
  ),
})
